export const APPROVED = "Odobreno";
export const REVIEW = "U obradi";
export const DENIED = "Odbijeno";

export const INACTIVE = "INACTIVE";
